<script>
import { mapActions, mapGetters } from "vuex";
import Global from "@/constants/Global.js";
import moment from "moment";
import itemCategories from "@/enum/item-category";
import itemStatus from "@/enum/item-status";
import requestSituation from "@/enum/request-situation";

export default {
  methods: {
    ...mapActions([
      "fetchItemProfile",
      "fetchItemMessages",
      "postItemMessage",
      "fetchUserInventory",
      "fetchItemRequestMade",
      "fetchItemRequestReceived",
      "acceptItemRequest",
      "declineItemRequest",
      "setItem",
      "resetNewItem",
      "resetItemImage",
      "fetchImageItem",
      "setImage",
      "updateItem",
      "setNewItemGroups",
      "setNewItemStep",
      "removeNewItemAtGroup",
      "setNewItemAvailableOnlyToGroups",
      "userInvetoryMergeRequests",
      "setItemInterested",
      "setActivitiyNotifications",
      "mergeRequestsReceivedMade",
      "updateItemStatus",
      "setReadRequests",
      "setReadSent",
      "setReadReceived",
      "setUnreadRequests",
      "getItemHistory",
      "deleteItem",
      "fetchRandomItems",
      "setFetchingActivityPage",
      "getItemStatus"
    ]),
    getItemImagePath(item) {
      if (item.isbn_image_link) return item.isbn_image_link;
      if (item) return `${Global.getServerDomain()}/images/item/${item.id}.jpg`;
      return `${Global.getServerDomain()}/images/item/1.jpg`;
    },
    getItemValue(item) {
      if (item.cash === 0 && item.points === 0) {
        return '<span class="free-price">FREE</span>';
      } else if (item.cash === 0) {
        return `<span class="points-price"> ${item.points} pts</span>`;
      } else if (item.points === 0) {
        return `<span class="cash-price">$${item.cash} </span>`;
      } else {
        return `<span class="points-price">${item.points} pts / </span><span class="cash-price">$${item.cash}</span>`;
      }
    },
    getItemType(item) {
      try {
        if (item.type === 1) {
          return "<div>GIVE</div>";
        } else if (item.type === 2) {
          return "<div>RECEIVE</div>";
        } else if (item.type === 3) {
          return "<div>LEND</div>";
        } else {
          return "<div>BORROW</div>";
        }
      } catch (error) {
        console.log(error);
      }
    },
    getItemCategory(item) {
      if (
        item === undefined ||
        item.category === undefined ||
        itemCategories[item.category].label === undefined
      )
        return "";
      const label = itemCategories[item.category].label || "";
      return label;
    },
    getItemCategoryIconPath(item) {
      const category = itemCategories[item.category] || {};
      return {
        icon: category.icon,
        iconClass: category.iconClass,
      };
    },
    storeItemSession() {
      sessionStorage.setItem("item", JSON.stringify(this.newItem));
    },
    async getStoredItemSession() {
      if (
        sessionStorage.getItem("item").title &&
        sessionStorage.getItem("item").description
      ) {
        let retrievedItem = JSON.parse(sessionStorage.getItem("item"));
        let base64 = await this.urltoFile(retrievedItem.image);
        retrievedItem.image_file = base64;
        await this.setItem({ sessionItem: retrievedItem });
      }
    },
    getItemDescription(item) {
      return item.description;
    },
    getItemTitle(item) {
      try {
        if (item === undefined) {
          return "";
        }
        if (item.title !== undefined) {
          return `${item.title}`;
        }
      } catch (error) {
        console.log(error);
      }
    },
    getPosterName(item) {
      if (item.user.firstName || item.user.firstname)
        return `${item.user.firstName}`;
      return `${item.user.username}`;
    },
    getRequestUserName(request) {
      if (!request.sUser) {
        if (request.item.poster) {
          let user = request.item.poster;
          return `${user.firstName}` || `${user.username}`;
        } else {
          return "";
        }
      }
      if (request.sUser.firstname) {
        return `${request.sUser.firstName}`;
      } else if (request.sUser.username) {
        return `${request.sUser.username}`;
      }
    },
    async urltoFile(url) {
      return await fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
          return new File([blob], "sessionFile", { type: "image" });
        });
    },
    async toBase64(file) {
      let reader = new FileReader();
      return await new Promise((resolve) => {
        reader.onloadend = (e) => {
          resolve(e.target.result);
        };
        reader.readAsDataURL(file);
      });
    },
    getItemCondition(item) {
      if (item.condition === 1) {
        return "New";
      } else if (item.condition === 2) {
        return "Like new";
      } else if (item.condition === 3) {
        return "Used";
      } else {
        return "Worn";
      }
    },
    getItemAvailability(item) {
      if (item.requests && Object.keys(item.requests) > 0) {
        const acceptedRequest = item.request.find(
          (r) => r.situation === requestSituation.ACCEPTED
        );
        return (Object.keys(acceptedRequest) <= 0)
      } else {
        return (item.status === itemStatus.IDLE)
      }
    },
    editButtomAvailable(item) {
      let edit = true;
      if (item.posterId === this.loggedUser.id && item.requests != undefined) {
        const accepted = item.requests.some(
          (r) => r.situation === requestSituation.ACCEPTED
        );
        const open = item.requests.some(
          (r) => r.situation === requestSituation.OPEN
        );
        if (open || accepted) {
          edit = false;
        } 
      }
      return edit;
    },
    getLastItemTimeStamp(item) {
      if (item.feedType) {
        if (item.feedType === "NEW_MEMBER") {
          return item.updatedAt !== null
            ? `${item.updatedAt}`
            : `${item.createdAt}`;
        }
      }
      return `${item.createdAt}`;
    },
  },
  computed: {
    ...mapGetters({
      itemProfile: "getItemProfile",
      itemPostFeaturedImage: "getNewItemImage",
      imageFile: "getImageFile",
      itemRequestsReceived: "getItemRequestsReceived",
      userInventory: "getUserInventory",
      userInventoryWithRequests: "getInventoryWithRequests",
      newItem: "getNewItem",
      itemPaymentType: "getNewItemPaymentType",
      itemPaymentPoints: "getNewItemPaymentPoints",
      itemPaymentCash: "getNewItemPaymentCash",
      newItemAtGroups: "getNewItemAtGroups",
      newItemAtGroupsId: "getNewItemAtGroupsIds",
      itemStep: "getNewItemStep",
      availableOnlyToGroups: "getAvailableOnlyToGroups",
      myRequestsMade: "getItemRequestsMade",
      interestedItem: "getInterestedItem",
      activityNotifications: "getActivityNotifications",
      searchQuery: "getQuery",
      mergedRequests: "getMergedRequestes",
      randomItems: "getRandomItems",
      isFetchingActivityPage: "getIsFetchingActivityPage",
    }),
  },
  filters: {
    date(date) {
      if (!date) return "";
      const dt = new Date(date);
      const f = (d) => (d < 10 ? "0" + d : d);
      return (
        f(dt.getMonth() + 1) + "/" + f(dt.getDate()) + "/" + dt.getFullYear()
      );
    },
    relativeDate(date) {
      if (!date) return "";

      const dt = moment(date);
      moment.updateLocale("en", {
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "a few seconds",
          ss: "%d seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          w: "a week",
          ww: "%d weeks",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years",
        },
      });

      return dt.fromNow();
    },
  },
};
</script>
